export default __webpack_public_path__ + "static/media/Logo.8a187f4d.svg";